export const recordVersions = ['5.0.5.105548', '5.0.5.105710']
export function isVersionValid(input: string | null): boolean {
  // 检查 input 是否为 null 或空字符串
  if (input === null || input.trim() === '') {
    return false; // 返回 false，表示无效
  }

  // 创建一个正则表达式，匹配版本号和子版本号
  const versionRegex = new RegExp(`^(${recordVersions.join('|')})(\\.\\d+)?$`);
  
  return versionRegex.test(input);
}
